import apiWithAuth from './apiWithAuth';

const termsOfUseApi = {

  // Get the latest terms of use
  getTermsOfUse: async () => {
    try {
      const response = await apiWithAuth.get('/website-main/terms-of-use/public');
      return { success: true, data: response.data };
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: true, data: null }; // No terms exists yet
      }
      return { success: false, error: error.response?.data?.error || 'Failed to load terms of use' };
    }
  },

  // Create or update terms of use
  saveTermsOfUse: async (mainHeading, sections) => {
    try {
      const response = await apiWithAuth.put('/website-main/terms-of-use/terms-of-use', { mainHeading, sections });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to save terms of use' };
    }
  },

  // Delete terms of use
  deleteTermsOfUse: async () => {
    try {
      await apiWithAuth.delete('/website-main/terms-of-use/terms-of-use');
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to delete terms of use' };
    }
  },
};

export default termsOfUseApi;